module.exports = __webpack_public_path__ + "img/qr.8fd36ef8.png";